import { render, staticRenderFns } from "./userMGT-detail.vue?vue&type=template&id=1fc1238b&scoped=true&"
import script from "./userMGT-detail.vue?vue&type=script&lang=js&"
export * from "./userMGT-detail.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-detail.vue?vue&type=style&index=0&id=1fc1238b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1238b",
  null
  
)

export default component.exports